import React, { Component } from 'react';
import CategoryTemplate, { dateArray } from './CategoryTemplate';
import { I18n } from 'react-redux-i18n';
import { getLocale, getShortName, settingEnabled } from '../js/auth';
import { gotoTop } from '../js/chooseMenuItem';
import { getMenuCategory } from '../js/admin';
import moment from 'moment';
import Keyboard from './Keyboard';
import menuitemutil from '../js/admin/menuitem';

class CategoryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: [],
            selectedType: props.type || (props.myStatus.restaurant_settings?.drinks?.default ? "drink" : "meal"),
            searchTerm: "",
            searchTermTemp: "",
            autoClickFirst: false,
            showKeyboard: false
        };
        this.searchTermRef = React.createRef();
    }

    hits = 0;

    handleCategorySelect = (categoryId) => {
        this.setState((prevState) => ({
            selectedCategory: prevState.selectedCategory === categoryId ? [] : [categoryId]
        }));
    };

    componentDidUpdate(prevProps) {
        if (this.props.reset && !prevProps.reset) {
            console.log("CategoryList: reset selection due to props.reset");
            this.setState({
                selectedType: prevProps.type || (prevProps.myStatus.restaurant_settings?.drinks?.default ? "drink" : "meal"),
                selectedCategory: [], searchTerm: "", searchTermTemp: ""
            });
        }
    }

    render() {
        // Guard: only render UI when myStatus and restaurant_settings are available
        if (!this.props.myStatus || !this.props.myStatus.restaurant_settings) {
            return null; // or a loading spinner if desired
        }

        const { categories, ...rest } = this.props;
        const { selectedCategory, selectedType, searchTerm } = this.state;
        let visibleCategories = categories;
        if (selectedCategory) {
            visibleCategories = categories.filter(cat => selectedCategory.length === 0 || selectedCategory?.[0] === cat.id);
        }
        var visibleDrinkCategories = visibleCategories.filter(cat => cat.entityType === "DrinkCategory").map(cat => ({ ...cat }));
        var visibleMealCategories = visibleCategories.filter(cat => cat.entityType === "MealCategory").map(cat => ({ ...cat }));
        var visibleAllCategories = selectedType === "drink" ? [...visibleDrinkCategories, ...visibleMealCategories] : [...visibleMealCategories, ...visibleDrinkCategories];
        var tabContentClass = "tab-content";
        const categoryIsSelected = selectedCategory.length > 0;
        var calendarView = false;
        var daysArray = [];
        var weeksArray = [];
        var style = {};

        this.hits = 0;

        //check if search term is in name or manufacturer or labels or barcodes
        if (searchTerm) {
            var searchTermLower = searchTerm.toLowerCase();
            if (searchTermLower.length === 13 && searchTermLower.startsWith('28')) {
                searchTermLower = searchTermLower.substring(2, 7);
            }
            const barcodeSearch = searchTermLower.startsWith('.') ? Number(searchTermLower.substring(1)) : Number(searchTermLower) > 10000 ? Number(searchTermLower) : null;
            function checkMatch(category) {
                category.activeMenuItems = category.activeMenuItems.filter(item => {
                    if (barcodeSearch) {
                        const barcodesMatch = item.barcodes && item.barcodes.some(barcode => barcode.id === barcodeSearch);
                        return barcodesMatch;
                    } else {
                        const nameMatch = getShortName(item).toLowerCase().includes(searchTermLower);
                        const manufacturerMatch = item.manufacturer && item.manufacturer.toLowerCase().includes(searchTermLower);
                        const labelsMatch = item.labels && item.labels.some(label => label.name.toLowerCase().includes(searchTermLower));
                        return nameMatch || manufacturerMatch || labelsMatch;
                    }
                });
                category.activeMenuCategories = category.activeMenuCategories.map(c => ({ ...c })).filter(subcat => checkMatch(subcat));
                return category.activeMenuItems.length > 0 || category.activeMenuCategories.length > 0;
            }
            visibleDrinkCategories = visibleMealCategories = visibleAllCategories.filter(cat => checkMatch({ ...cat }));
        }

        if (categoryIsSelected) {
            tabContentClass += " categorySelected";
            //get the last selected category
            const categorySelected = getMenuCategory(selectedCategory[selectedCategory.length - 1]);
            if (!categorySelected || !categorySelected.isTop || !categorySelected.pos) {
                setTimeout(() => {
                    this.setState({ selectedCategory: [] });
                }, 0);
            }
            if (categorySelected) {
                calendarView = !!(categorySelected.activeMenuItems.find(m => m.defaultFromDate));
                if (calendarView) {
                    //find all the weekdays used
                    var days = new Set();
                    var weeks = new Set();
                    var startOfWeek = moment().startOf('week');
                    categorySelected.activeMenuItems.filter(m => m.isTop && m.defaultPos).forEach(m => {
                        if (m.defaultFromDate && m.defaultToDate) {
                            if (moment(m.defaultFromDate).isBefore(startOfWeek) && moment(m.defaultToDate).isBefore(startOfWeek)) {
                                //skip past weeks
                                return;
                            }
                            const dates = dateArray(m);
                            days = dates.map(d => {
                                const dd = moment(d).isoWeekday();
                                return dd;
                            }).reduce((acc, day) => {
                                acc.add(day);
                                return acc;
                            }, days);
                            weeksArray = dates.map(d => {
                                const ww = moment(d).startOf('week').valueOf();
                                return ww;
                            }).reduce((acc, week) => {
                                if (moment(week).isSameOrAfter(moment().startOf('week'))) {
                                    acc.add(week);
                                }
                                return acc;
                            }, weeks);
                        } else if (m.defaultFromDate) {
                            if (moment(m.defaultFromDate).isBefore(startOfWeek)) {
                                //skip past weeks
                                return;
                            }
                            const dd = moment(m.defaultFromDate).isoWeekday();
                            days.add(dd);
                            const ww = moment(m.defaultFromDate).startOf('week').valueOf();
                            weeks.add(ww);
                        }
                    });
                    if (days.size > 0) {
                        tabContentClass += " calendar-view";
                        daysArray = Array.from(days).sort();
                        weeksArray = Array.from(weeks).sort();
                        style['display'] = "grid";
                        style['gridTemplateColumns'] = `auto repeat(${daysArray.length}, minmax(0, 1fr))`;
                    }
                }
            }
        }

        var types = selectedType === "drink" ? ["drink", "meal"] : ["meal", "drink"];

        return (
            <>
                {this.settingEnabled('drinks') && this.settingEnabled('meals') &&
                    <ul key="1" className="nav nav-tabs nav-justified" >
                        {this.settingEnabled('drinks') &&
                            <li key="drinks" className="nav-item" onClick={() => this.setState({ selectedType: "drink", selectedCategory: [], searchTerm: "", searchTermTemp: "" })}>
                                <span key="drinks" id="drinks" className={"nav-link" + (selectedType === "drink" ? " active" : "")} data-toggle="tab" style={{ borderBottom: "unset", width: "min-content", display: "flex", flexFlow: "column" }}>
                                    <img key="drinks" src="img/drink-64.png" />
                                </span>
                            </li>
                        }
                        {this.settingEnabled('meals') &&
                            <li key="meals" className="nav-item" onClick={() => this.setState({ selectedType: "meal", selectedCategory: [], searchTerm: "", searchTermTemp: "" })}>
                                <span key="meals" id="meals" className={"nav-link" + (selectedType === "meal" ? " active" : "")} data-toggle="tab" style={{ borderBottom: "unset", width: "min-content", display: "flex", flexFlow: "column" }}>
                                    <img key="meals" src="img/food-64.png" />
                                </span>
                            </li>
                        }
                    </ul>
                }
                <div key="2" className={tabContentClass} style={{ backgroundColor: "inherit", height: "100%", overflow: "hidden" }} >
                    {types.map(type => (
                        <React.Fragment key={type + "_fragment"}>
                            {selectedType === type && this.settingEnabled(type + "s") &&
                                (<div key={type + "_menu_tab"} id={type + "_menu_tab"} className={"scrollable-y tab-pane menu active " + (searchTerm ? "searchterm" : "")}  >
                                    <div key={type + "_menu"} id={type + "_menu"} className="menu container" style={style}>
                                        {calendarView && (
                                            <>
                                                <div key="daysHeader" />
                                                {daysArray.map(dayNum =>
                                                    <div key={dayNum} d={dayNum} className="day" >{I18n.t("admin_local.days")[dayNum - 1]}</div>)}
                                            </>
                                        )}
                                        {calendarView ? (weeksArray.map(week =>
                                            <React.Fragment key={week}>
                                                <div key={moment(week).isoWeek() + '1'} d={moment(week).isoWeek()} className="week nr" style={{ gridColumn: "span " + (2) }}>{moment(week).isoWeek() + ". " + I18n.t("admin_local.week")}</div>
                                                <div key={moment(week).isoWeek() + '2'} d={moment(week).isoWeek()} className="week per" style={{ gridColumn: "span " + (daysArray.length - 1) }}>{moment(week).format("MMMM-DD") + " - " + moment(week).endOf('week').format("MMMM-DD")}</div>
                                                {(type === "drink" ? visibleDrinkCategories : visibleMealCategories).map((cat) => (
                                                    <CategoryTemplate
                                                        key={cat.id}
                                                        {...cat}
                                                        week={week}
                                                        selectedCategory={selectedCategory}
                                                        onSelectCategory={this.handleCategorySelect}
                                                        onUnSelectCategory={this.handleCategoryUnSelect}
                                                        resetSelection={this.resetSelection}
                                                        searchTerm={searchTerm}
                                                        autoClickFirst={this.state.autoClickFirst}
                                                        increaseHits={this.increaseHits}

                                                        {...rest}
                                                    />))}
                                            </React.Fragment>
                                        )) : (type === "drink" ? visibleDrinkCategories : visibleMealCategories).map((cat) => (
                                            <CategoryTemplate
                                                key={cat.id}
                                                {...cat}
                                                selectedCategory={selectedCategory}
                                                onSelectCategory={this.handleCategorySelect}
                                                onUnSelectCategory={this.handleCategoryUnSelect}
                                                resetSelection={this.resetSelection}
                                                searchTerm={searchTerm}
                                                autoClickFirst={this.state.autoClickFirst}
                                                increaseHits={this.increaseHits}
                                                {...rest}
                                            />
                                        ))}

                                    </div >
                                </div >)
                            }
                        </React.Fragment>
                    ))}

                </div>
                <div key="3" style={{ flexGrow: 1 }} />
                <div key="4" id="quickSearch">
                    {this.state.showKeyboard && <Keyboard input={this.searchTermRef?.current} insertEnter={this.resetSelection} backspaceCharacter={this.backspaceCharacter} insertCharacter={this.insertCharacter} />}
                    <div style={{ display: "flex", width: "100%" }}>
                        <input ref={this.searchTermRef} value={this.state.searchTermTemp} onChange={this.handleSearchChange} onKeyUp={this.handleSearchKeyUp} className=" search" id="search" type="text" enabled />
                        <button

                            onClick={() => this.setState({ showKeyboard: !this.state.showKeyboard })}
                            className="btn icon-keyboard"></button>
                    </div>
                </div>

            </>
        );
    }

    insertCharacter = (input, char) => {
        input.value = input.value + char;
        const event = new Event('input', { bubbles: true });
        input.dispatchEvent(event);
        this.handleSearchChange({ target: input });
    }

    backspaceCharacter = (input) => {
        input.value = input.value.slice(0, -1);
        const event = new Event('input', { bubbles: true });
        input.dispatchEvent(event);
        this.handleSearchChange({ target: input });
    }

    increaseHits = () => {
        this.hits += 1;
    }

    handleCategorySelect = (categoryId) => {
        this.setState((prevState) => ({
            selectedCategory: [...prevState.selectedCategory, categoryId]
        }));
    }
    handleCategoryUnSelect = (categoryId) => {
        this.setState((prevState) => ({
            selectedCategory: prevState.selectedCategory.filter(id => id !== categoryId)
        }));
    }

    resetSelection = () => {
        this.setState({ selectedCategory: [], searchTerm: "", searchTermTemp: "" });
    }

    settingEnabled = (path) => {
        try {
            var settings = this.props.myStatus.restaurant_settings;
            path.split('/').forEach(prop => {
                settings = settings[prop];
            })
            return settings == true || settings.enabled == true;
        } catch (ex) {
            console.log("Restaurant setting missing: " + path);
        }
        return false;
    }





    handleSearchChange = (event) => {
        const searchTerm = event.target.value;
        this.setState({ searchTermTemp: searchTerm, selectedCategory: [] }, () => {
            if (this.autoClickFirstTimeout)
                clearTimeout(this.autoClickFirstTimeout);
            if (this.searchTimeout)
                clearTimeout(this.searchTimeout);
            if (searchTerm.length > 1 && !searchTerm.startsWith('.'))
                this.searchTimeout = setTimeout(() => {
                    clearTimeout(this.searchTimeout);
                    this.setState({ searchTerm: this.state.searchTermTemp }, () => {
                        if (this.state.searchTermTemp && this.hits === 1)
                            this.autoClickFirstTimeout = setTimeout(() => {
                                this.autoClickFirstTimeout = null;
                                this.setState({ autoClickFirst: true }, () => {
                                    if (this.state.autoClickFirst) {
                                        this.setState({ autoClickFirst: false, searchTerm: "", searchTermTemp: "" });
                                    }
                                });
                            }, 500);
                    });
                }, 500);
            else
                this.setState({ searchTerm: "" });
        });
    }

    handleSearchKeyUp = (event) => {
        if (event.key === "Enter") {
            this.setState({ searchTerm: this.state.searchTermTemp }, () => {
                if (this.state.searchTermTemp && this.hits === 1)
                    this.autoClickFirstTimeout = setTimeout(() => {
                        this.autoClickFirstTimeout = null;
                        this.setState({ autoClickFirst: true }, () => {
                            if (this.state.autoClickFirst) {
                                this.setState({ autoClickFirst: false, searchTerm: "", searchTermTemp: "" });
                            }
                        });
                    }, 500);
            });
        }
    }

    componentWillUnmount() {
        if (this.autoClickFirstTimeout) {
            clearTimeout(this.autoClickFirstTimeout);
        }
    }
}



export default CategoryList;
